import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add-new--sprite",
  "use": "add-new--sprite-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol viewBox=\"0 0 28 28\" xmlns=\"http://www.w3.org/2000/svg\" id=\"add-new--sprite\">\n<path d=\"M14.2406 0.666626C6.88056 0.666626 0.907227 6.63996 0.907227 14C0.907227 21.36 6.88056 27.3333 14.2406 27.3333C21.6006 27.3333 27.5739 21.36 27.5739 14C27.5739 6.63996 21.6006 0.666626 14.2406 0.666626ZM20.9072 15.3333H15.5739V20.6666H12.9072V15.3333H7.57389V12.6666H12.9072V7.33329H15.5739V12.6666H20.9072V15.3333Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol